module.exports = __webpack_public_path__ + "static/media/librarian.819dfb95.svg";